import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  MobileItinerayDetailComponent
} from '@shared/flight-itinerary/components/mobile-itinerary-detail/mobile-itinerary-detail.component';
import { FlightsFiltersContainer } from '@shared/filters/components/flights-filters/flights-filters.container';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { MobileFlexibleDatesComponent } from '@flight-results/components/mobile-flexible-dates/mobile-flexible-dates.component';
import {
  FlightResultsExchangesContainer
} from '@flight-results/components/containers/flight-results-exchanges/flight-results-exhange.container';
import {
  FlightConfirmExchangeContainer
} from '@flight-results/components/containers/flight-confirm-exchange/flight-confirm-exchange.container';
import {
  FlightResidualExchangeContainer
} from '@flight-results/components/containers/flight-residual-exchange/flight-residual-exchange.container';
import { IndividualAirFilterContainer } from '@shared/magic-filter-bar/individual-air-filter/individual-air-filter.container';

export const flightExchangeRootRoute = 'flight-exchanges';
export const routeDetail = 'route-detail';
export const filtersRoute = 'filters';
export const calendarRoute = 'calendar';
export const flexiDatesRoute = 'flexi-dates';
export const confirmExchange = 'confirm-exchange';
export const residualExchange = 'residual-exchange';
export const singleFilterRoute = 'single-filter';

const children = [
  {
    path: routeDetail,
    outlet: 'detail',
    component: MobileItinerayDetailComponent,
  },
  {
    path: filtersRoute,
    outlet: 'detail',
    component: FlightsFiltersContainer
  },
  {
    path: singleFilterRoute,
    outlet: 'detail',
    component: IndividualAirFilterContainer
  },
  {
    path: calendarRoute,
    outlet: 'detail',
    component: SearchBarMobileCalendarContainer,
  },
  {
    path: flexiDatesRoute,
    outlet: 'detail',
    component: MobileFlexibleDatesComponent
  },
  {
    path: confirmExchange,
    outlet: 'confirm',
    component: FlightConfirmExchangeContainer,
  },
  {
    path: residualExchange,
    outlet: 'confirm',
    component: FlightResidualExchangeContainer,
  }
];

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: FlightResultsExchangesContainer
      },
      {
        path: ':itinerary_id/:reservation_id/:departure/:arrival/:departure_sec_number/:departure_sector_change/:departure_date'
          + '/:adults/:children/:infants/:baggage_included/:original_departure_date/:original_route'
          + '/:original_departure_date_time'
          + '/:with_assistance_and_longer_duration/:with_assistance_and_shorter_or_equal_duration'
          + '/:route_change_is_disabled',
        component: FlightResultsExchangesContainer,
        children: children
      },
      {
        path: ':itinerary_id/:reservation_id/:departure/:arrival/:departure_sec_number/:departure_sector_change/:departure_date'
          + '/:arrival_sec_number/:arrival_sector_change/:arrival_date/:adults/:children/:infants/:baggage_included'
          + '/:original_departure_date/:original_arrival_date/:original_route'
          + '/:original_departure_date_time/:original_arrival_date_time'
          + '/:with_assistance_and_longer_duration/:with_assistance_and_shorter_or_equal_duration'
          + '/:route_change_is_disabled',
        component: FlightResultsExchangesContainer,
        children: children
      }
    ])
  ],
  exports: [RouterModule]
})
export class FlightExchangesRoutingModule { }
